export const setUnsavedChanges = changes => {
	return {
		type: 'SETUNSAVEDCHANGES',
		payload: {
			unsavedChanges: changes
		}
	}
};
